import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import {CommonStatus} from "@/enums/status";

export class WardParams {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    search = undefined;
    status = CommonStatus.Active;
    districtId = undefined;
}
